import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'

import AlertWaiting from '../../molecules/AlertWaiting'
import AlertError from '../../molecules/AlertError'
import TitleRoxo from '../../atoms/TitleRoxo'
import Menu from '../../molecules/Menu'
import Footer from '../../molecules/Footer'

import * as Styled from './styles'

const PERFIL_CONFIG = {
  parceiro: { storageKey: 'parceiroData' },
  empresa:  { storageKey: 'empresaData'  },
  motoboy:  { storageKey: 'motoboyData'  },
}

const ROTA_PAINEL = '/painel'

export default function AuthUsuario() {
  const history = useHistory()
  const [waiting, setWaiting] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('')

  const [view, setView] = useState('login')

  const [userEmail, setUserEmail] = useState('')
  const [perfisDisponiveis, setPerfisDisponiveis] = useState([])
  const [tipoPerfilSelecionado, setTipoPerfilSelecionado] = useState(null)

  const { register, handleSubmit, reset } = useForm()

  const fetchAPI = async (method, data) => {
    setWaiting(true)
    setErrorMessage('')
    setSuccessMessage('')
    try {
      const response = await fetch('https://moovery.app/api/indique_ganhe/index.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ method, data })
      })
      const result = await response.json()
      setWaiting(false)
      return result
    } catch (error) {
      setWaiting(false)
      setErrorMessage('Erro de conexão com o servidor.')
      return { success: false }
    }
  }

  const finalizarLogin = (res) => {
    const config = PERFIL_CONFIG[res.tipo_perfil]

    if (!config) {
      setErrorMessage('Tipo de perfil não reconhecido.')
      return
    }

    Object.values(PERFIL_CONFIG).forEach(c => localStorage.removeItem(c.storageKey))

    localStorage.setItem(config.storageKey, JSON.stringify(res.dados))
    localStorage.setItem('userTipoPerfil', res.tipo_perfil)

    history.push(ROTA_PAINEL)
  }

  const dispararOtp = async (email, tipoPerfil) => {
    const res = await fetchAPI('solicitarCodigoOtp', { email, tipo_perfil: tipoPerfil })

    if (res.success) {
      setUserEmail(email)
      setTipoPerfilSelecionado(tipoPerfil)
      setView('otp-verify')
      setSuccessMessage(res.message)
    } else {
      setErrorMessage(res.message || 'Erro ao solicitar código.')
    }
  }

  const onSubmitEmail = async (data) => {
    const res = await fetchAPI('identificarPerfisPorEmail', { email: data.email })

    if (!res.success) {
      setErrorMessage(res.message || 'Não encontramos nenhum cadastro ativo com esse e-mail.')
      return
    }

    const perfis = res.perfis || []

    if (perfis.length === 1) {
      await dispararOtp(data.email, perfis[0].tipo)
      return
    }

    setUserEmail(data.email)
    setPerfisDisponiveis(perfis)
    setView('select-profile')
  }

  const onSelecionarPerfil = async (tipoPerfil) => {
    await dispararOtp(userEmail, tipoPerfil)
  }

  const onSubmitOtpVerify = async (data) => {
    const res = await fetchAPI('validarCodigoOtp', {
      email: userEmail,
      tipo_perfil: tipoPerfilSelecionado,
      codigo: data.codigo,
    })

    if (res.success) {
      finalizarLogin(res)
    } else {
      setErrorMessage(res.message)
    }
  }

  const voltarAoInicio = () => {
    setView('login')
    setUserEmail('')
    setPerfisDisponiveis([])
    setTipoPerfilSelecionado(null)
    setErrorMessage('')
    setSuccessMessage('')
    reset()
  }

  const getSubtitle = () => {
    if (successMessage) return successMessage
    if (view === 'login') return 'Acesse usando apenas o seu e-mail.'
    if (view === 'select-profile') return `Encontramos mais de um cadastro para ${userEmail}. Selecione com qual perfil deseja acessar.`
    if (view === 'otp-verify') return `Enviamos um código para ${userEmail}`
    return ''
  }

  return (
    <>
      {waiting && <AlertWaiting />}
      {errorMessage && <AlertError>{errorMessage}</AlertError>}

      <Menu hideLinks />
      <Styled.Page>
        <Styled.Shell>
          <Styled.Card style={{ maxWidth: '600px', margin: '0 auto' }}>
            <Styled.CardHeader>
              <TitleRoxo>
                {view === 'login' && 'Acesso ao Painel'}
                {view === 'select-profile' && 'Selecione seu perfil'}
                {view === 'otp-verify' && 'Verificação de Segurança'}
              </TitleRoxo>
              <Styled.Subtitle style={{ color: successMessage ? '#00C853' : 'inherit' }}>
                {getSubtitle()}
              </Styled.Subtitle>
            </Styled.CardHeader>

            {view === 'login' && (
              <form onSubmit={handleSubmit(onSubmitEmail)}>
                <Styled.FormGrid style={{ gridTemplateColumns: '1fr' }}>
                  <Styled.InputField>
                    <label>E-mail</label>
                    <input {...register('email', { required: true })} type="email" placeholder="seu@email.com" />
                    <span style={{ fontSize: '12px', color: '#666', marginTop: '4px', display: 'block' }}>
                      Enviaremos um código seguro de 6 dígitos para o seu e-mail.
                    </span>
                  </Styled.InputField>
                </Styled.FormGrid>
                <br/>

                <Styled.Actions style={{ flexDirection: 'column', gap: '10px' }}>
                  <Styled.ButtonOrange type="submit" disabled={waiting}>Receber Código</Styled.ButtonOrange>
                </Styled.Actions>
              </form>
            )}

            {view === 'select-profile' && (
              <>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '8px' }}>
                  {perfisDisponiveis.map((perfil) => (
                    <button
                      key={perfil.tipo}
                      type="button"
                      disabled={waiting}
                      onClick={() => onSelecionarPerfil(perfil.tipo)}
                      style={{
                        padding: '16px',
                        border: '2px solid #7241a1',
                        borderRadius: '10px',
                        background: '#fff',
                        cursor: 'pointer',
                        textAlign: 'left',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px',
                        transition: 'all .2s',
                      }}
                      onMouseEnter={(e) => { e.currentTarget.style.background = '#f8f5fc' }}
                      onMouseLeave={(e) => { e.currentTarget.style.background = '#fff' }}
                    >
                      <span style={{ fontSize: '12px', color: '#7241a1', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1px' }}>
                        {perfil.tipo_rotulo}
                      </span>
                      <span style={{ fontSize: '16px', color: '#333' }}>
                        {perfil.nome}
                      </span>
                    </button>
                  ))}
                </div>

                <Styled.Actions style={{ flexDirection: 'column', gap: '10px', marginTop: '20px' }}>
                  <span
                    style={{ cursor: 'pointer', color: '#7241a1', fontSize: '14px', textAlign: 'center' }}
                    onClick={voltarAoInicio}
                  >
                    Voltar ao início
                  </span>
                </Styled.Actions>
              </>
            )}

            {view === 'otp-verify' && (
              <form onSubmit={handleSubmit(onSubmitOtpVerify)}>
                <Styled.FormGrid style={{ gridTemplateColumns: '1fr' }}>
                  <Styled.InputField>
                    <label>Código de Verificação</label>
                    <input
                      {...register('codigo', { required: true, minLength: 6, maxLength: 6 })}
                      placeholder="000000"
                      style={{ fontSize: '24px', letterSpacing: '8px', textAlign: 'center' }}
                      maxLength={6}
                    />
                  </Styled.InputField>
                </Styled.FormGrid>

                <Styled.Actions style={{ flexDirection: 'column', gap: '10px' }}>
                  <Styled.ButtonOrange type="submit" disabled={waiting}>
                    Acessar Painel
                  </Styled.ButtonOrange>
                  <span
                    style={{ cursor: 'pointer', color: '#7241a1', fontSize: '14px', textAlign: 'center' }}
                    onClick={voltarAoInicio}
                  >
                    Voltar ao Início
                  </span>
                </Styled.Actions>
              </form>
            )}

          </Styled.Card>
        </Styled.Shell>
      </Styled.Page>
      <Footer />
    </>
  )
}
